// ParentMenu.js
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Menu, Drawer } from 'antd';
import ChildMenu from './ChildMenu';
import {
	DashboardOutlined,
	GlobalOutlined,
	LineChartOutlined,
	ApiOutlined,
} from '@ant-design/icons';
import './help.css';

class ParentMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      childrenDrawer: false,
      childMenu: 'Overview'  // Set default value
    };
  }

  handleClick = e => {
    if (e.key) {
      this.setState({
        childrenDrawer: true,
        childMenu: e.key
      });
    }
  };

  onChildrenDrawerClose = () => {
    this.setState({ 
      childrenDrawer: false,
      childMenu: 'Overview'  // Reset to default value when closing
    });
  };

  render() {
    const { userTheme } = this.props;
    const { SubMenu } = Menu;
    const { childMenu } = this.state;

    return (
      <div className='help-documentation'>
        <div className={userTheme === 'dark' ? 'menu-container-dark' : 'menu-container'}>
		<Menu
			onClick={this.handleClick}
			defaultOpenKeys={['overview', 'DynamicLink']}
			defaultSelectedKeys={['Overview']}
			mode="inline"
			theme={userTheme}
			className={userTheme === 'dark' ? 'menu-dark' : 'menu-light'}
			>
			{/* <Menu.Item key="Overview" icon={<DashboardOutlined />}>
				Overview
			</Menu.Item> */}
			
			<Menu.Item key="DynamicLink" icon={<GlobalOutlined />}>
        Dynamic links
			</Menu.Item>
			
			
		</Menu>
        </div>

        <Drawer
          title={`Documentation - ${childMenu || 'Overview'}`}
          width={720}
          onClose={this.onChildrenDrawerClose}
          open={this.state.childrenDrawer}
          className="documentation-drawer"
        >
          <ChildMenu menu={childMenu || 'Overview'} />
        </Drawer>
      </div>
    );
  }
}

// Map Redux state to component props
const mapStateToProps = state => ({
  userTheme: state.user.userTheme
});

// Map Redux actions to component props
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({}, dispatch)
});

// Connect component to Redux store
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ParentMenu));
